// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

export const UserProfileImage = ({src, alt}: {src?: string; alt?: string}) => {
  if (src == null) {
    return <Icon name="users-team" />;
  }

  return (
    <img
      src={src}
      onError={(img: any) => (img.target.style.visibility = 'hidden')}
      alt={alt}
      className="ui avatar image"
      style={{
        filter: 'none', // important to prevent scary images in dark mode
        width: '24px',
        height: '24px',
        objectFit: 'contain',
        margin: 0,
        flexShrink: 0,
      }}
    />
  );
};
